export default __webpack_public_path__ + "static/media/circle-1.fa372f61.png";